<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer001">
<p class="Aheads"><span class="com-rorohiko-pagestaker-style CharOverride-1">iv</span></p>
<p class="_about" id="_idParaDest-1">About the Author</p>
<p class="txni ParaOverride-1">Deborah Blake is the author of over a dozen books on modern Witchcraft, including <span class="ital">The Eclectic Witch’s Book of Shadows</span>, <span class="ital">The Little Book of Cat Magic,</span> and <span class="ital">Everyday Witchcraft</span>, as well as the acclaimed <span class="ital">Everyday Witch Tarot</span> and <span class="ital">Everyday Witch Oracle</span>. She has also written three paranormal romance and urban fantasy series for Berkley, and her new cozy mystery series launched with <span class="CharOverride-2">Furbidden Fatality</span> in 2021. Deborah lives in a 130-year-old farmhouse in upstate New York with numerous cats who supervise all her activities, both magical and mundane.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// About.vue?f271ca4a